import { render } from "./ColorSwatchMenu.vue?vue&type=template&id=dc3f0850&scoped=true&ts=true"
import script from "./ColorSwatchMenu.vue?vue&type=script&lang=ts"
export * from "./ColorSwatchMenu.vue?vue&type=script&lang=ts"

import "./ColorSwatchMenu.vue?vue&type=style&index=0&id=dc3f0850&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc3f0850"]])

export default __exports__